// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3r8-n","label":"CategoryService_label__1VO6S","location":"CategoryService_location__2qFet"};